// extracted by mini-css-extract-plugin
module.exports = {"navBtnWrapper":"_25nFaqcNfX3v6i2PvNgHIm","nonStick":"_3Bwg99l-ZG0NmCMGVkqgIR","backButton":"_3d500VH_8AMDFbKa_kqSGO","divider":"YeFfDCRHMuuS7m_gu_Shw"};